import * as React from 'react';
// @ts-ignore
import { useState } from 'react';
import ApiClientModule from '../../../../services/ApiClientModule';

import { get } from 'lodash';
import { Guid, replacer } from '../../../helpers/Utils';

// types
import type { CreatorErrorSetter, CreatorProps } from '../types';

interface PdfFile {
  id: string;
  url: string;
  value: string;
  isLoader: boolean;
  isBase64: boolean;
  arrayBuffer: any;
}

interface Props extends CreatorProps {
  setError: CreatorErrorSetter;
}

export const usePdfFile = (props: Props) => {
  const [pdf, setPdf] = useState<PdfFile>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const defaultFilename = `${
    props.schema?.extra?.defaultFilename || 'file'
  }.pdf`;

  const getPdfFile = async (): Promise<any> => {
    const { fileLocationUrl } = props.schema;

    return new Promise((resolve, reject) => {
      try {
        setIsLoading(true);
        setPdf(null);

        // Инициирую api
        // Создаю строку с URL откуда забирать файл
        const apiClientModule = new ApiClientModule();
        const sourceObject = Object.keys(fileLocationUrl.pathFromProps).reduce(
          (acc, index) => {
            const item = fileLocationUrl.pathFromProps[index];
            return {
              ...acc,
              [index]: get(props, item),
            };
          },
          {},
        );

        const result = replacer(fileLocationUrl.url, sourceObject);

        // Пытаюсь забрать файл
        apiClientModule.getFileArrayBuffer(
          result,
          {},
          {
            success: async (response) => {
              const arrayBuffer = response.data;
              const base64 = `data:application/pdf;base64,${Buffer.from(
                arrayBuffer,
              ).toString('base64')}`;

              setPdf({
                id: Guid.newGuid(),
                url: base64,
                value: defaultFilename,
                isLoader: false,
                isBase64: true,
                arrayBuffer,
              });

              resolve({
                id: Guid.newGuid(),
                url: base64,
                value: defaultFilename,
                isLoader: false,
                isBase64: true,
                arrayBuffer,
              });
              setIsLoading(false);

              return response;
            },
            error: ({ response }) => {
              const json = JSON.parse(
                String.fromCharCode.apply(null, new Uint8Array(response.data)),
              );
              props.dispatcher.setErrors(json.field_errors);
              reject(json.field_errors);
              setIsLoading(false);
            },
          },
        );
      } catch (error) {
        props.setError('Ошибка получения файла', <p>Ошибка получения файла</p>);
        reject(error);
      }
    });
  };

  return { pdf, isLoading, getPdfFile };
};
